import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

type StateWithUserRoleMembership = { userRoleMembership: FilterState };

const userRoleMembershipsSlice = createSlice({
    name: 'userRoleMemberships',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default userRoleMembershipsSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = userRoleMembershipsSlice.actions;
export const selectFilters = (state: StateWithUserRoleMembership) => state.userRoleMembership.filters;
